function querySelector(selector: string, parent: Document | Element = document): Element | null {
    return parent.querySelector(selector);
}

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        find(selector: string): Element | null;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.find = function (selector: string): Element | null {
    return querySelector(selector, this);
};

// ----------------------------------------------------------------------------

export default querySelector;
